import React from 'react';
import { C } from '../styles/theme';

export type ButtonVariant = 'primary' | 'secondary' | 'danger' | 'ghost';
export type ButtonSize   = 'sm' | 'md';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  loading?: boolean;
}

const VARIANTS: Record<ButtonVariant, React.CSSProperties> = {
  primary:   { background: C.primary,    color: C.white,   border: 'none' },
  secondary: { background: C.secondary,  color: C.white,   border: 'none' },
  danger:    { background: C.error,      color: C.white,   border: 'none' },
  ghost:     { background: 'transparent', color: C.text2,  border: `1px solid ${C.border}` },
};

const SIZES: Record<ButtonSize, React.CSSProperties> = {
  sm: { padding: '5px 12px', fontSize: 12, borderRadius: 6 },
  md: { padding: '8px 16px', fontSize: 13, borderRadius: 8 },
};

export function Button({
  variant = 'primary',
  size = 'md',
  loading,
  children,
  disabled,
  style,
  ...rest
}: ButtonProps): React.ReactElement {
  return (
    <button
      disabled={disabled ?? loading}
      style={{
        ...VARIANTS[variant],
        ...SIZES[size],
        fontWeight: 600,
        cursor: disabled ?? loading ? 'not-allowed' : 'pointer',
        opacity: disabled ?? loading ? 0.6 : 1,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        transition: 'opacity .15s, filter .15s',
        whiteSpace: 'nowrap',
        ...style,
      }}
      {...rest}
    >
      {loading ? '...' : children}
    </button>
  );
}
